module.exports = __webpack_public_path__ + "static/Nightbot-1ee8f178050890f2efbd2b8811a17800.jpg";